/**
 * 封装请求
 *
 * @date 2019-08-15
 * @author chenyongzheng
 */

// 引入axios
import axios from 'axios'

// 引入Vue
import Vue from 'vue'

// 引入elementUI Message模块
import {Message} from 'element-ui'

/**
 * Http
 * @type {{ajaxPut(*=, *=): Promise<any>, handleError(*=): void, ajaxDelete(*, *): Promise<any>, ajaxGet(*=, *=): Promise<any>, ajaxPost(*=, *=): Promise<any>}}
 */
const Http = {

    /**
     * get
     *
     * @param url
     * @param params
     * @returns {Promise<any>}
     */
    ajaxGet(url, params) {
        return new Promise((resolve, reject) => {

            axios.get(url, {params: params}).then((result) => {
                resolve(result);
            }).catch((error) => {
                this.handleError(error);
                reject(error);
            })
        })
    },

    /**
     * post
     *
     * @param url
     * @param params
     * @returns {Promise<any>}
     */
    ajaxPost(url, params) {

        return new Promise((resolve, reject) => {

            axios.post(url, params).then(result => {
                resolve(result);
            }).catch((error) => {

                this.handleError(error);
                reject(error);
            })
        })
    },

    /**
     * put
     *
     * @param url
     * @param params
     * @returns {Promise<any>}
     */
    ajaxPut(url, params) {

        return new Promise((resolve, reject) => {

            axios.put(url, params).then(result => {

                resolve(result);
            }).catch((error) => {

                this.handleError(error);
                reject(error);
            })
        })
    },

    /**
     * delete
     *
     * @param url
     * @param params
     * @returns {Promise<any>}
     */
    ajaxDelete(url, params) {

        return new Promise((resolve, reject) => {

            axios.delete(url, {data: params}).then(result => {
                resolve(result);
            }).catch((error) => {
                this.handleError(error);
                reject(error);
            })
        })
    },

    /**
     * 处理异常
     *
     * @param msg
     */
    handleError(msg) {

        Message.closeAll();
        Message({
            message: msg,
            type: 'error',
            duration: 3 * 1000
        })
    },

}

// 挂在原型链
Vue.prototype.$http = Http;



// WEBPACK FOOTER //
// ./src/utils/http.js